import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import moment from "moment";
import { MessageService } from 'primeng/api';
import { Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';
import { AppointmentService } from 'src/app/admin/servicies/appointment.service';
import { BaseComponent } from 'src/app/shared/components/base.component';
import { Constants } from 'src/app/shared/constants';
import { DateFormatModel } from 'src/app/shared/models/common/date-format-model';
import { WipStatusBTmapping } from 'src/app/shared/models/common/wip-status';
import { BTSalesOrderUpdateRequestModel } from 'src/app/shared/models/request/salesorder-update-request-model-brightree';
import { AppointmentUpdateStatusRequestModel } from 'src/app/shared/models/response/appointment/appointment-updatestatus-request-model';
import { SalesOrderInfoResponseModel } from 'src/app/shared/models/response/appointment/sales-order-info-reponse-model';
import { PatientSideBarInfo, TherapistAppointmentsForClinicRemoteResponseModel, TherapistAppointmentsForRoadHomeResponseModel } from 'src/app/shared/models/response/appointment/therapist-appointment-by-appointment_type';
import { WIPStatesResponseModel } from 'src/app/shared/models/response/appointment/wip-states-response-model';
import { ResultOfT } from 'src/app/shared/models/response/result';
import { FeatureGroupService } from 'src/app/shared/services/featuregroup.service';
import { WebStorageService } from 'src/app/shared/services/web-storage.service';
import { TheraistAppointmentService } from 'src/app/shared/services/theraistappointment.service';
import { CancelVoidResponseModel } from 'src/app/shared/models/response/settings/settings-classificationtype-response-model';
import { AdminSettingsService } from 'src/app/admin/servicies/admin-settings.service';
import {FeatureFlagService} from 'src/app/shared/services/feature-flag.service';
import { FeatureFlags } from 'src/app/shared/feature-flags';
import { WipStatusBtService } from 'src/app/services/wip-status-bt.service';

@Component({
    selector: 'app-patient-detail-sidebar',
    templateUrl: './patient-detail-sidebar.component.html',
    styleUrls: ['./patient-detail-sidebar.component.sass'],
    standalone: false
})

export class PatientDetailSidebarComponent extends BaseComponent implements OnInit, OnChanges {
  AppointmentStatus: any;
  salesOrderType: string = 'AppointmentRequest';
  private unsubscriber = new Subject<boolean>();
  private progress = new Subject<boolean>();
  salesOrder: SalesOrderInfoResponseModel;
  patientEmail: string = "";
  patientPhone: string = "";
  patientMobileNumber: string = "";
  therapistClinicResult: TherapistAppointmentsForClinicRemoteResponseModel;
  therapistRoadHomeResult: TherapistAppointmentsForRoadHomeResponseModel;
  schWIPStatus: WIPStatesResponseModel;
  wipStatusModel: WIPStatesResponseModel[];
  wipStatusBTMappingResponseModel: WipStatusBTmapping[];
  @Input() patientDetail: PatientSideBarInfo;
  @Input() salesOrderid: number;
  patientHeaderDetail: PatientSideBarInfo;
  appDateFormat: DateFormatModel;
  appointmentNote: string;
  canUpdateStatue: boolean;
  isStatusUpdated: boolean = false;
  isStatusUpdatedinDB: boolean = false;
  displayStatus: string;
  AppointmentStatusUpdate: boolean;
  @Output() wipsStatusCreated = new EventEmitter<{ appWipStatus: string, schAppointmentId: number }>();
  isBrightreeSystemAppUpdate: Boolean = true;
  isBrightreeSystemAppUpdateSetting: Boolean = false;
  therapistId: number;
  therapistName: string;
  facilityTimeZone: string = '';
  isFutureAppt: boolean = false;
  reason: CancelVoidResponseModel;
  reasonsResponseModel: CancelVoidResponseModel[];
  cancellationReasonsResponseModel: CancelVoidResponseModel[];
  voidReasonsResponseModel: CancelVoidResponseModel[];
  bDisaplyCancelVoidReason: boolean= false;
  calendarFullAppointmentStatus:boolean = false;

  //41466
  timeZoneList: { name: string; code: string; shortName: string; orgcode: string; displayName: string; countryName: string }[];
  selectedPatientTimeZone: { name: string; code: string; shortName: string; orgcode: string; displayName: string; countryName: string };
  @Input() groupOptions: any[] = [];
  @Output() groupPatientSelected = new EventEmitter<any>();
  selectedGroupPatient: any;
 constructor(private appointmentService: AppointmentService,
    messageService: MessageService,
    private theraistAppointmentService: TheraistAppointmentService,
    private webStorageService: WebStorageService,
    private settingsService: AdminSettingsService,
    private featureFlagService: FeatureFlagService,
    private featureGroupService: FeatureGroupService,
    private wipStatusBtService: WipStatusBtService,
  private cd: ChangeDetectorRef
  ) {
    super(messageService);
    this.appDateFormat = this.webStorageService.getDateFormat();

    // Initialize timeZoneList early so it's available in ngOnChanges
    this.timeZoneList = [
      { name: 'Eastern Time (UTC -5:00)', code: 'UTC -5', shortName: 'EST', orgcode: 'UTC-5', displayName: 'EST', countryName: 'America/New_York' },
      { name: 'Central Time (UTC -6:00)', code: 'UTC -6', shortName: 'CST', orgcode: 'UTC-6', displayName: 'Central', countryName: 'America/Chicago' },
      { name: 'Mountain Time (UTC -7:00)', code: 'UTC -7', shortName: 'MST', orgcode: 'UTC-7', displayName: 'Mountain', countryName: 'America/Boise' },
      { name: 'Arizona Mountain Time (UTC-7:00)', code: 'UMST -7', orgcode: 'UMST-7', shortName: 'AMST', displayName: 'Mountain', countryName: 'America/Phoenix' },
      { name: 'Pacific Time (UTC -8:00)', code: 'UTC -8', shortName: 'PST', orgcode: 'UTC-8', displayName: 'Pacific', countryName: 'America/Los_Angeles' },
      { name: 'Hawaiian Standard Time (UTC -10:00)', code: 'UTC -10', orgcode: 'UTC-10', shortName: 'HST', displayName: 'Hawaiian', countryName: 'Pacific/Honolulu' }
    ];

    this.patientHeaderDetail = new PatientSideBarInfo();
    this.wipStatusModel = [];

    this.featureFlagService.getFeatureFlag(FeatureFlags.CalendarFullAppointmentStatus).subscribe(x => {
      this.calendarFullAppointmentStatus = x.responseModel.isEnabled;
    });
  }

  ngOnInit() {
    this.schWIPStatus = new WIPStatesResponseModel();

    const currentUserToken = this.webStorageService.getCurrentUserToken();
    const currentUserAuthToken = this.webStorageService.getCurrentUserAuthToken();
    if (currentUserToken && currentUserAuthToken.token) {
      this.therapistId = currentUserToken.userId;
      this.therapistName = currentUserToken.userFullName;
      this.facilityTimeZone = currentUserToken.crmTimeZone;
    }
    else {
      this.therapistId = 0;
      this.therapistName = '';
      this.facilityTimeZone = 'EST';
    }

    this.getSalesOrderStatus();
    this.getWipStatusBTmapping();
    this.getCancelVoidReasons();
  }

ngOnChanges(changes: SimpleChanges) {
    this.getUpdateStatusPermission();
    
    if (this.wipStatusModel && this.wipStatusModel.length > 0 && this.isAllowToSetNoShowStatus())
      this.isFutureAppt = true;
    else
      this.isFutureAppt = false;

    this.appointmentNote = "";
    for (let property in changes) {
      if (property === 'patientDetail') {
        if (this.patientDetail) {
          this.patientHeaderDetail = this.patientDetail;
          if (this.patientHeaderDetail.status == 'NoShow') {
            this.patientHeaderDetail.status = 'No Show';
          }
        }
      }
      if (property === 'salesOrderid') {
        if (this.salesOrderid && this.salesOrderid > 0) {
          this.getSalesOrderInfo(this.salesOrderid);
        }
      }
      if (property === 'groupOptions') {
        if (this.groupOptions && this.groupOptions.length > 0) {
          this.selectedGroupPatient = this.groupOptions[0];
        }
      }
    }
  }
  
 private getSalesOrderInfo(SalesOrderId) {
    if (!SalesOrderId || SalesOrderId == 0) {
      this.loading = false;
      return;
    }
    this.loading = true;
    this.cd.detectChanges();
    
    this.appointmentService.GetSalesOrderById(SalesOrderId, true)
      .pipe(takeUntil(this.unsubscriber), finalize(() => this.progress.next(false)))
      .toPromise()
      .then((result) => {
        this.processResult<SalesOrderInfoResponseModel>(result, () => {
          if (result.isSuccess) {
            if (result.responseModel != undefined && result.responseModel != null) {
              this.salesOrder = result.responseModel;
              if (this.salesOrder.patientInfo.crmPatientEmailAddress) {
                this.patientEmail = this.salesOrder.patientInfo.crmPatientEmailAddress;
              }
              else {
                this.patientEmail = "-";
              }
              if (this.salesOrder.patientInfo.crmPatientPhoneNo) {
                this.patientPhone = this.salesOrder.patientInfo.crmPatientPhoneNo;
              }
              else {
                this.patientPhone = "";
              }
              if (this.salesOrder.patientInfo.crmPatientMobileNumber) {
                this.patientMobileNumber = this.salesOrder.patientInfo.crmPatientMobileNumber;
              }
              else {
                this.patientMobileNumber = "";
              }
              if (this.salesOrder.crmSalesorderStatus) {
                let status = this.wipStatusModel.find(x => x.wipStatesName == this.salesOrder.crmSalesorderStatus)
                if (status) {
                  this.isStatusUpdated = true;
                  this.displayStatus = status.wipStatesName;
                }
                else
                {
                  this.isStatusUpdated = false;
                  this.displayStatus = "";
                }
                this.schWIPStatus = status;
              }
              this.loading = false;
              this.cd.markForCheck();
              this.cd.detectChanges();  // <-- Force update after data loads
            }
          }
        });
      }).catch((httpResponseError) => {
        this.loading = false;
        this.cd.markForCheck();
        this.cd.detectChanges();
        this.showErrorMessage(httpResponseError.message);
      });
  }

  private getSalesOrderStatus() {
    this.progress.next(true);
    this.theraistAppointmentService.GetAllWIPStatesBySalesOrderType(this.salesOrderType)
      .pipe(takeUntil(this.unsubscriber), finalize(() => this.progress.next(false)))
      .toPromise()
      .then((result) => {
        this.processResult<WIPStatesResponseModel[]>(result, () => {
          let salesOrderStatus = result.responseModel;
          console.log(this.calendarFullAppointmentStatus);
         
          if (this.calendarFullAppointmentStatus == true) {
            this.wipStatusModel = salesOrderStatus.
              filter(x => x.wipStatesName.toLowerCase() == 'complete'
                || x.wipStatesName.toLowerCase() == 'no show'
                || x.wipStatesName.toLowerCase() == 'cancel'
                || x.wipStatesName.toLowerCase() == 'void'
                || x.wipStatesName.toLowerCase() == 'void review'
              );
              
          }
          else {
            this.wipStatusModel = salesOrderStatus.
            filter(x => x.wipStatesName.toLowerCase() == 'complete'
              || x.wipStatesName.toLowerCase() == 'no show');
          }
           this.cd.markForCheck();
          this.cd.detectChanges();
        });
      }).catch((httpResponseError) => {
        this.showErrorMessage(httpResponseError.message);
      });
  }

  
  onGroupPatientChange(event: any) {
    this.selectedGroupPatient = event.value;
    this.groupPatientSelected.emit(this.selectedGroupPatient);
  }

  async onUpdateAppointment(AppoinmentId) {

    if (this.schWIPStatus?.wipStatesName == undefined) {
      this.showWarningMessage("Please select appointment status.");
      return;
    }
    if (this.bDisaplyCancelVoidReason == true && this.reason?.salesOrderVoidReason == undefined) {
      this.showWarningMessage("Please select reason for status.");
      return;
    }

    //41466
    let message: string = "No Show status can not be set before Appointment time";
    if (this.schWIPStatus.wipStatesName.toLowerCase() == 'complete')
      message = "Complete status can not be set before Appointment time";

    if (((this.schWIPStatus.wipStatesName.toLowerCase() == 'complete') || (this.schWIPStatus.wipStatesName.toLowerCase() == 'no show')) &&
      (this.isAllowToSetNoShowStatus())) {
      this.showWarningMessage(message);
      return;
    }

      this.loading = true;
    this.cd.detectChanges();

    try {
      if (!this.isStatusUpdated) {
        await this.updateAppointmentStatus();
      }

      if (this.isStatusUpdated && AppoinmentId > 0) {
        let appointmentUpdateStatusRequestModel = new AppointmentUpdateStatusRequestModel();
        appointmentUpdateStatusRequestModel.SchAppointmentId = AppoinmentId;
        appointmentUpdateStatusRequestModel.SchComments = this.appointmentNote == undefined ? "" : this.appointmentNote;

        const result = await this.theraistAppointmentService.UpdateAppointmentDetailComment(appointmentUpdateStatusRequestModel)
          .pipe(takeUntil(this.unsubscriber))
          .toPromise();

        let noteUpdated = false;
        this.processResult<boolean>(result, () => {
          if (result.responseModel) {
            this.getSalesOrderInfo(this.salesOrderid);
            this.AppointmentStatusUpdate = false;
            noteUpdated = true;
          }
        });

        this.loading = false;
        this.cd.detectChanges();

        if (noteUpdated) {
          this.showSuccessMessage("Appointment note has been updated.");
        }
        return;
      }
    } catch (httpResponseError) {
      this.showErrorMessage(httpResponseError.message);
    } finally {
      this.loading = false;
      this.cd.detectChanges();
    }
  }

  async updateAppointmentStatus(): Promise<void> {
    if (!this.schWIPStatus) {
      this.showWarningMessage("Please select appointment status.");
      return;
    }
    let appointmentRequestBT = new BTSalesOrderUpdateRequestModel();
    appointmentRequestBT.IsUpdateToBrightree = false;
    appointmentRequestBT.IsDeliveryNoteOverride = true;
    appointmentRequestBT.IsOrderNoteOverride = true;
    appointmentRequestBT.OrderNote = null;
    appointmentRequestBT.DeliveryNote = null;
    appointmentRequestBT.PractitionerName = null;
    appointmentRequestBT.PractitionerId = 0;
    appointmentRequestBT.DeliveryTechnicianId = 0;
    appointmentRequestBT.ScheduledDeliveryStartDateString = null;
    appointmentRequestBT.ScheduledDeliveryStartTimeString = null;
    appointmentRequestBT.ScheduledDeliveryStartDate = null;
    appointmentRequestBT.WIPDateNeededString = moment().toDate().toDateString();
    appointmentRequestBT.WIPDateNeeded = moment().toDate();
    appointmentRequestBT.CrmModifiedBy = this.patientHeaderDetail.therapistID;
    let selectedWipStaus: WipStatusBTmapping;
    if (this.schWIPStatus.wipStatesName.toLowerCase() == 'complete') {
      this.patientHeaderDetail.status = 'Complete';
      selectedWipStaus = this.wipStatusBTMappingResponseModel.find(x => x.crmWipstatusNameSa.toLowerCase() == 'complete');
    }
    if (this.schWIPStatus.wipStatesName.toLowerCase() == 'no show') {
      this.patientHeaderDetail.status = 'No Show';
      selectedWipStaus = this.wipStatusBTMappingResponseModel.find(x => x.crmWipstatusNameSa.toLowerCase() == 'noshow')
    }
    if (this.schWIPStatus.wipStatesName.toLowerCase() == 'cancel') {
      this.patientHeaderDetail.status = 'Cancel';
      selectedWipStaus = this.wipStatusBTMappingResponseModel.find(x => x.crmWipstatusNameSa.toLowerCase() == 'cancel');
    }
    if (this.schWIPStatus.wipStatesName.toLowerCase() == 'void') {
      this.patientHeaderDetail.status = 'Void';
      selectedWipStaus = this.wipStatusBTMappingResponseModel.find(x => x.crmWipstatusNameSa.toLowerCase() == 'void');
    }
    if (this.schWIPStatus.wipStatesName.toLowerCase() == 'void review') {
      this.patientHeaderDetail.status = 'Void Review';
      selectedWipStaus = this.wipStatusBTMappingResponseModel.find(x => x.crmWipstatusNameSa.toLowerCase() == 'voidreview');
    }

    if (selectedWipStaus) {
      appointmentRequestBT.WIPStateName = selectedWipStaus.crmWipstatusNameBt;
      appointmentRequestBT.WIPStateKey = selectedWipStaus.wipStatusRCMId;
      appointmentRequestBT.IsUpdateToBrightree = selectedWipStaus.crmIsUpdateToBrigthree;
      appointmentRequestBT.WIPAssignedToKey = selectedWipStaus.crmWIPAssignedToKey;
    }

    appointmentRequestBT.IsUpdateToBrightree = !this.isBrightreeSystemAppUpdate;
    let statusId = selectedWipStaus.crmWipstatusId;
    let appointmentUpdateStatus: AppointmentUpdateStatusRequestModel[] = new Array();
    let appointmentUpdateStatusRequestModel = new AppointmentUpdateStatusRequestModel();
    appointmentUpdateStatusRequestModel.SchAppointmentId = this.salesOrder.schAppointmentId;
    appointmentUpdateStatusRequestModel.SchAppointmentStatus = statusId;
    appointmentUpdateStatusRequestModel.CrmFacilityId = this.salesOrder.crmFacilityId;
    appointmentUpdateStatusRequestModel.CrmTherapistId = this.patientHeaderDetail.therapistID;
    appointmentUpdateStatusRequestModel.modifiedByUserInfoId = this.patientHeaderDetail.therapistID;
    appointmentUpdateStatusRequestModel.salesOrderUpdateRequestModelBT = appointmentRequestBT;
    appointmentUpdateStatusRequestModel.isUpdateByTherapist = true;
    appointmentUpdateStatusRequestModel.TherapistName = this.therapistName;
    appointmentUpdateStatusRequestModel.dateTimeLastModified = this.patientHeaderDetail.datetimeLastModified;
    if (this.bDisaplyCancelVoidReason == true) {
      appointmentUpdateStatusRequestModel.SchComments = this.appointmentNote;
      appointmentUpdateStatusRequestModel.schCancelReason = this.reason?.salesOrderVoidReason;
    }

    appointmentUpdateStatus.push(appointmentUpdateStatusRequestModel);

    try {
      const checkResult = await this.theraistAppointmentService.CheckAppointmentUpdatedStatus(appointmentUpdateStatus)
        .pipe(takeUntil(this.unsubscriber))
        .toPromise();

      let alreadyUpdated = false;
      this.processResult<boolean>(checkResult, () => {
        if (checkResult.responseModel) {
          alreadyUpdated = true;
        }
      });

      if (alreadyUpdated) {
        this.loading = false;
        this.cd.detectChanges();
        this.showInfoMessage("The appointment has been rescheduled or updated. The screen will be refreshed.");
        this.wipsStatusCreated.emit({ appWipStatus: selectedWipStaus.appAlias, schAppointmentId: this.salesOrder.schAppointmentId });
        this.AppointmentStatusUpdate = false;
        this.getSalesOrderInfo(this.salesOrderid);
        return;
      }

      const updateResult = await this.theraistAppointmentService.UpdateAppointmentStatus(appointmentUpdateStatus)
        .pipe(takeUntil(this.unsubscriber))
        .toPromise();

      let statusUpdated = false;
      this.processResult<boolean>(updateResult, () => {
        if (updateResult.responseModel) {
          statusUpdated = true;
        }
      });

      if (!statusUpdated) {
        return;
      }

      if (this.salesOrder.schAppointmentId > 0) {
        if (this.bDisaplyCancelVoidReason == true) {
          let commentRequestModel = new AppointmentUpdateStatusRequestModel();
          commentRequestModel.SchAppointmentId = this.salesOrder.schAppointmentId;
          commentRequestModel.SchComments = this.appointmentNote == undefined ? "" : this.appointmentNote;

          const commentResult = await this.theraistAppointmentService.UpdateAppointmentDetailComment(commentRequestModel)
            .pipe(takeUntil(this.unsubscriber))
            .toPromise();

          let commentUpdated = false;
          this.processResult<boolean>(commentResult, () => {
            if (commentResult.responseModel) {
              this.getSalesOrderInfo(this.salesOrderid);
              this.wipsStatusCreated.emit({ appWipStatus: selectedWipStaus.appAlias, schAppointmentId: this.salesOrder.schAppointmentId });
              this.AppointmentStatusUpdate = false;
              commentUpdated = true;
            }
          });

          if (commentUpdated) {
            this.loading = false;
            this.cd.detectChanges();
            this.showSuccessMessage("Appointment status and note has been updated.");
          }
        }
        else {
          this.getSalesOrderInfo(this.salesOrderid);
          this.loading = false;
          this.cd.detectChanges();
          this.showSuccessMessage("Appointment status has been updated.");
          this.wipsStatusCreated.emit({ appWipStatus: selectedWipStaus.appAlias, schAppointmentId: this.salesOrder.schAppointmentId });
          this.AppointmentStatusUpdate = false;
        }
      }
      this.isStatusUpdatedinDB = true;
    } catch (httpResponseError) {
      this.showErrorMessage(httpResponseError.message);
    }
  }
  onChange(event) {
    if (event.value) {
      this.reason = event.value;
    }
  }

  async getCancelVoidReasons() {
    this.loading = true;
    this.settingsService.getCancelVoidReasons()
      .pipe(takeUntil(this.unsubscriber), finalize(() => this.loading = false))
      .subscribe((result: ResultOfT<any>) => {
        this.processResult<any>(result, () => {
          if (result.responseModel != undefined && result.responseModel != null) {
            this.reasonsResponseModel = result.responseModel;
            const myClonedArray = [];
            this.reasonsResponseModel.forEach(val => myClonedArray.push(Object.assign({}, val)));
            this.voidReasonsResponseModel = myClonedArray.filter(x => x.salesOrderReasonType === 'Void');
            this.cancellationReasonsResponseModel = myClonedArray.filter(x => x.salesOrderReasonType === 'Cancel');
          }
        });
      }, (httpResponseError) => {
        this.showErrorMessage(httpResponseError.message);
      });
  }

  async getWipStatusBTmapping() {
    this.loading = true;
    this.wipStatusBtService.getMappings()
      .pipe(takeUntil(this.unsubscriber), finalize(() => this.loading = false))
      .subscribe((result: ResultOfT<any>) => {
        this.processResult<any>(result, () => {
          this.wipStatusBTMappingResponseModel = result.responseModel;
        });
      }, (httpResponseError) => {
        this.showErrorMessage(httpResponseError.message);
      });

  }

  private async getUpdateStatusPermission() {
    await this.featureGroupService.getSettings(Constants.SettingKeys.AllowTherapistToUpdateAppointmentStatus)
      .pipe(takeUntil(this.unsubscriber), finalize(() => this.progress.next(false)))
      .subscribe((result) => {
        this.processResult<any>(result, () => {
          if (result.isSuccess) {
            if (result.responseModel)
              this.canUpdateStatue = (result.responseModel.schSettingValue.toLowerCase() === 'true');
          }
        });
      });
  }


  appointmentStatusDialog() {
    this.schWIPStatus = new WIPStatesResponseModel();
    if (!this.isAllowToSetNoShowStatus()) //41466
      this.AppointmentStatusUpdate = true;
    else {
      this.showWarningMessage("'No Show' or 'Complete' status can not be set before Appointment time");
    }
    this.bDisaplyCancelVoidReason = false;
    this.reason = null;
    this.appointmentNote = "";
  }
  onBTSelect(status: any) {

    if (status.checked) {
      this.isBrightreeSystemAppUpdate = true;
    }
    else {
      this.isBrightreeSystemAppUpdate = false;
    }
  }


  isAllowToSetNoShowStatus(): boolean {
    if (!this.patientDetail || !this.timeZoneList || !this.timeZoneList.length) {
      return false;
    }

    this.selectedPatientTimeZone = this.timeZoneList.find(x => x.orgcode == this.patientDetail?.patientTimeZone);
    if (!this.selectedPatientTimeZone) {
      return false;
    }

    var orgappDateTime = moment.tz(this.patientDetail?.appointmentDate, this.selectedPatientTimeZone.countryName);

    this.selectedPatientTimeZone = this.timeZoneList.find(x => x.code == this.appDateFormat.timeZone);
    if (!this.selectedPatientTimeZone) {
      return false;
    }

    var appDate = orgappDateTime.tz(this.selectedPatientTimeZone.countryName).format('DD-MMM-yyyy hh:mm:ss A');
    var appDateTime = moment(appDate).toDate();

    var date = moment(new Date()).tz(this.selectedPatientTimeZone.countryName).format('DD-MMM-yyyy hh:mm:ss A');
    var currentDateTime = moment(date).toDate();

    return false;
  }


  changeWipStatus(event: any) {
    //41466
    this.schWIPStatus = event.value;
    let message: string = "No Show status can not be set before Appointment time";
    if (this.schWIPStatus.wipStatesName.toLowerCase() == 'complete')
      message = "Complete status can not be set before Appointment time";

    if (this.isAllowToSetNoShowStatus()) {
      this.showWarningMessage(message);
      return;
    }
    let selectedWipStaus: WipStatusBTmapping;
    let result = [... this.wipStatusModel.filter(item => item.wipStatesName === this.schWIPStatus.wipStatesName)];
    if (result.length != null && result.length > 0) {
      if (this.schWIPStatus.wipStatesName.toLowerCase() == 'complete') {
        selectedWipStaus = this.wipStatusBTMappingResponseModel.find(x => x.crmWipstatusNameSa.toLowerCase() == 'complete');
      }
      else if (this.schWIPStatus.wipStatesName.toLowerCase() == 'no show') {
        selectedWipStaus = this.wipStatusBTMappingResponseModel.find(x => x.crmWipstatusNameSa.toLowerCase() == 'noshow');
      }
      else if (this.schWIPStatus.wipStatesName.toLowerCase() == 'cancel') {
        selectedWipStaus = this.wipStatusBTMappingResponseModel.find(x => x.crmWipstatusNameSa.toLowerCase() == 'cancel');
      }
      else if (this.schWIPStatus.wipStatesName.toLowerCase() == 'void') {
        selectedWipStaus = this.wipStatusBTMappingResponseModel.find(x => x.crmWipstatusNameSa.toLowerCase() == 'void');
      }
      else if (this.schWIPStatus.wipStatesName.toLowerCase() == 'void review') {
        selectedWipStaus = this.wipStatusBTMappingResponseModel.find(x => x.crmWipstatusNameSa.toLowerCase() == 'voidreview');
      }
      if (selectedWipStaus) {
        this.isBrightreeSystemAppUpdateSetting = selectedWipStaus.crmIsUpdateToBrigthree;
        this.isBrightreeSystemAppUpdate = !this.isBrightreeSystemAppUpdateSetting;
      }
    }

    if ((this.schWIPStatus.wipStatesName.toLowerCase() == 'cancel') ||
    (this.schWIPStatus.wipStatesName.toLowerCase() == 'void') ||
    (this.schWIPStatus.wipStatesName.toLowerCase() == 'void review')){

      this.bDisaplyCancelVoidReason = true;

      if (this.schWIPStatus.wipStatesName.toLowerCase() == 'cancel')
        this. reasonsResponseModel = this.cancellationReasonsResponseModel;
      else
        this. reasonsResponseModel = this.voidReasonsResponseModel;
    }
  }

}
